import {
  DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS,
  DOWNLOADSETTLEMENTREPORTPARTNER_FAILED,
  RESET_DOWNLOADSETTLEMENTREPORTPARTNER,
  LOADING_DOWNLOADSETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetDownloadSettlementReportPartner = () => {
  return { type: RESET_DOWNLOADSETTLEMENTREPORTPARTNER };
};

// const generateWalletTransactionReportFileReq =
//   (userData, authTokenIs) => async (dispatch) => {
//     dispatch({ type: LOADING_GENERATEWALLETTRANSACTIONREPORTFILE });
//     await partnerServices
//       .post(
//         "generateWalletTransactionReportFile", userData, { headers: { AuthToken: authTokenIs } }
//       )
//       .then((res) => {
//         switch (res.data.status) {
//           case "success":
//             dispatch(generateWalletTransactionReportFileSuccess(res.data));
//             break;
//           default:
//             dispatch(generateWalletTransactionReportFileFailed(res.data));
//             break;
//         }
//       })
//       .catch((err) => {
//         dispatch({
//           type: NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE,
//           payload: err,
//         });
//       });
//   };


const downloadSettlementReportFileReq =
  (userData, authTokenIs, fileType) => async (dispatch) => {  // ✅ added fileType param
    dispatch({ type: LOADING_DOWNLOADSETTLEMENTREPORTPARTNER });
    await partnerServices
      .post(
        "downloadSettlementReport",
        userData,
        {
          headers: { AuthToken: authTokenIs },
          responseType: "blob", // ✅ KEY FIX — treat response as binary
        }
      )
      .then((res) => {
        // ✅ No res.data.status check — blob has no JSON body
        dispatch(downloadSettlementReportFileSuccess({
          status: "success",  // ✅ we set this manually
          blob: res.data,     // ✅ raw binary blob
          fileType: fileType, // ✅ "csv" or "pdf"
        }));
      })
      .catch((err) => {
        // ✅ If server returns error as JSON blob, parse it back
        if (err.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result);
              dispatch(downloadSettlementReportFileFailed(errorJson));
            } catch {
              dispatch(downloadSettlementReportFileFailed({ message: "Unknown error" }));
            }
          };
          reader.readAsText(err.response.data);
        } else {
          dispatch({
            type: NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER,
            payload: err,
          });
        }
      });
  };
function downloadSettlementReportFileSuccess(data) {
  return {
    type: DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS,
    payload: data,
  };
}
function downloadSettlementReportFileFailed(data) {
  return {
    type: DOWNLOADSETTLEMENTREPORTPARTNER_FAILED,
    payload: data,
  };
}

export {
  resetDownloadSettlementReportPartner,
  downloadSettlementReportFileReq,
};
